import graphql from 'graphql-tag'
import api from '@stores/apollo'

import { IPageInfo, IDMTableDepartment } from '@api'
import { DMTableDepartmentFragment, PageInfoFragment } from '@api/fragments'

export default function list({
  after,
  orderBy,
  first,
  queryString,
  flatten,
}: {
  after: string | null
  orderBy: string
  first: number
  queryString?: string
  flatten: boolean
}): Promise<{
  departments: IDMTableDepartment[]
  pageInfo: IPageInfo
  counters: { total: number }
}> {
  // ignore snake case
  // eslint-disable-next-line
  let where = { name_contains: queryString, isRoot: !flatten }
  return api.gql
    .query({ query: departmentListQuery, variables: { after, orderBy, first, where } })
    .then(
      ({
        data: {
          viewer: {
            company: {
              departmentConnection: { edges, pageInfo, counters },
            },
          },
        },
      }: {
        data: {
          viewer: {
            company: {
              departmentConnection: {
                edges: { node: IDMTableDepartment }[]
                pageInfo: IPageInfo
                counters: { total: number }
              }
            }
          }
        }
      }) => ({ departments: edges.map(({ node }) => node), pageInfo, counters })
    )
}

export const departmentListQuery = graphql`
  query DepartmentList(
    $after: String
    $orderBy: DepartmentOrderByEnum
    $first: Int
    $where: DepartmentWhereInput
  ) {
    viewer {
      company {
        departmentConnection(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...DMTableDepartmentFragment
            }
          }
        }
      }
    }
  }
  ${DMTableDepartmentFragment}
  ${PageInfoFragment}
`
